import logo from '../../assets/images/logo192.png'

const Logo = () => (
  <img className={'h-6 max-w-none'} alt={''} src={logo}/>
);

export default Logo